module.exports = __webpack_public_path__ + "img/ApacheFavicon.b16a9b03.png";